import React, { useContext } from 'react';

import { FaqApi } from '../apis';
import { api } from '../api';

const FaqApiContext = React.createContext(new FaqApi(api));

export const FaqApiProvider = FaqApiContext.Provider;
export const useFaqApi = (): FaqApi => useContext(FaqApiContext);
